import { merge } from 'lodash';
import { FETCH_TPA_SETTINGS_SUCCESS, UPDATE_TPA_SETTINGS_SUCCESS, } from './tpa-settings-actions';
export const INITIAL_STATE = { settings: {}, translations: {} };
const tpaSettingsReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case UPDATE_TPA_SETTINGS_SUCCESS:
        case FETCH_TPA_SETTINGS_SUCCESS:
            return merge({}, state, payload);
        default:
            return state;
    }
};
export default tpaSettingsReducer;
//# sourceMappingURL=tpa-settings-reducer.js.map